import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { publisherReportPageTabsData } from '../../../Mock/ReportsTabsData';
import Dashboard from '../Reports/Dashboard';
// import PublisherOverallReports from '../../../view/Publisher/Reports/PublisherOverallReports';
import ClicksToLeadReport from '../Reports/ClickToLeads';
// import AreaStudyReportsPage from '../Reports/AreaStudyReports';
import RawReports from '../Reports/RawReports';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs(props) {
  // console.log("props Tab", props)
  const [value, setValue] = React.useState(0);
 const {tabsProps}=props;
 const dashboardCampaigns=tabsProps.campaignsDropdown




  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} 
        aria-label="basic tabs example"
        
         TabIndicatorProps={{
          style: {
            backgroundColor: "#00AAE3",
            color:"#00AAE3" 
          }
        }}
         >
          {publisherReportPageTabsData.map((data,index)=>{
            return <Tab label={data.title} {...a11yProps(index)} /> 
          })} 
        </Tabs>
      </Box>
      <TabPanel value={value} index={0} className="tab-panel">
     <Dashboard  dropDownMenus={{dashboardCampaigns}}  publisher_id={props.tabsProps.publisherId}/>
      </TabPanel>
      <TabPanel value={value} index={1}  className="tab-panel">
     <ClicksToLeadReport  dropDownMenus={{dashboardCampaigns}} publisher_id={props.tabsProps.publisherId}/>
      </TabPanel>
      <TabPanel value={value} index={2}  className="tab-panel">
      <RawReports  dropDownMenus={{dashboardCampaigns}} publisher_id={props.tabsProps.publisherId}/>
       {/* <AreaStudyReportsPage  dropDownMenus={{dashboardCampaigns}}/> */}
      </TabPanel>
      {/* <TabPanel value={value} index={3}  className="tab-panel">
      
        <Dashboard  dropDownMenus={{dashboardCampaigns}} />
      </TabPanel> */}
    </Box>
  );
}
